import { render, staticRenderFns } from "./AiLogicDiagram.vue?vue&type=template&id=65c27536&scoped=true"
import script from "./AiLogicDiagram.vue?vue&type=script&lang=js"
export * from "./AiLogicDiagram.vue?vue&type=script&lang=js"
import style0 from "./AiLogicDiagram.vue?vue&type=style&index=0&id=65c27536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c27536",
  null
  
)

export default component.exports